import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-263d96b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "login-title" }
const _hoisted_5 = { class: "login-form" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["disabled", "textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.type === 2 ? _ctx.tvicBg : _ctx.type === 1 ? _ctx.bvicBg : _ctx.vicBg,
      class: "banner-bg",
      alt: "VIC banner"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.vicPrefix) + "VIC " + _toDisplayString(_ctx.$t('member-login')), 1),
      _createElementVNode("form", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          class: "form-input fw6",
          name: "EmailAddress",
          type: "email",
          placeholder: _ctx.$t('enter-email'),
          required: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
        }, null, 8, _hoisted_6), [
          [_vModelText, _ctx.email]
        ]),
        _withDirectives(_createElementVNode("input", {
          class: "form-input fw6",
          name: "Password",
          type: "password",
          placeholder: "********",
          required: "",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
        }, null, 512), [
          [_vModelText, _ctx.password]
        ]),
        _createElementVNode("div", {
          class: "form-error",
          textContent: _toDisplayString(_ctx.errorText)
        }, null, 8, _hoisted_7),
        _createElementVNode("button", {
          class: "form-submit btn",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onLogin && _ctx.onLogin(...args))),
          disabled: _ctx.requestingLogin,
          textContent: _toDisplayString(_ctx.$t('login'))
        }, null, 8, _hoisted_8)
      ])
    ])
  ]))
}